import { useTheme } from "next-themes";
import { useState } from "react";

import DcclLogo from "./../assets/DCCL-Logo.png";
import { customCancelButton, customLoginButton, customRecoverButton, themeBasedSignupFormControl } from "../components/customStyles";
import useBreakpoint from "../hooks/useBreakpoint";
import { userChangePassword } from "../services/auth.service";
import { useAuth } from "../store/AuthContext";
import toast from "react-hot-toast";
import { customToast } from "../components/toasts";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import LogoDark from '../assets/InvestorApp.png';
import { useI18n } from "../hooks/useI18n";

function UpdatePasswordPage() {
  const [formData, setFormData] = useState(() => ({
    old_password: "",
    password: "",
    confirm_password: "",
  }));
  const [formErrors, setFormErrors] = useState(() => ({
    old_password: false,
    password: false,
    confirm_password: false,
  }));

  const [viewPassword, setViewPassword] = useState(() => ({
    old_password: false,
    password: false,
    confirm_password: false,
  }));

  const [formProcessing, setFormProcessing] = useState(false);

  const { theme } = useTheme();

  const { user, logout } = useAuth();

  const { t } = useTranslation();

  const { isRTL } = useI18n();

  const navigate = useNavigate();

  const screenSize = useBreakpoint();

  const updateFormData = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const navigateToHome = () => {
    navigate("/dashboard", { replace: true });
  };

  const sendChangePasswordReq = async () => {
    setFormProcessing(true);

    await new Promise((res) => setTimeout(() => res(), 1000));

    try {
      if (!user) {
        toast((t) => customToast("you have to be logged in to change your password", "error", t), {
          duration: 3000,
          removeDelay: 1000,
          style: {
            padding: "0.75rem",
            margin: "0",
            minWidth: "200px",
            backgroundColor: "rgb(255,255,255)",
          },
        });
      } else {
        if (formData.password.localeCompare(formData.confirm_password) === 0) {
          const response = await userChangePassword(user?.data.email, formData.old_password, formData.password);

          if (!response.error) {
            toast((t) => customToast(response.message, "success", t), {
              duration: 3000,
              removeDelay: 1000,
              style: {
                padding: "0.75rem",
                margin: "0",
                minWidth: "200px",
                backgroundColor: "rgb(221, 204, 225)",
              },
            });

            setFormData(() => ({
              old_password: "",
              password: "",
              confirm_password: "",
            }))

            await new Promise(res => setTimeout(() => res(), 250));

            logout();

            toast((t) => customToast("Logout Successful", "success", t), {
              duration: 3000,
              removeDelay: 1000,
              style: {
                padding: "0.75rem",
                margin: "0",
                minWidth: "200px",
                backgroundColor: "rgb(221, 204, 225)",
              },
            });

            navigate("/auth/login", { replace: true });
          } else {
            if (Array.isArray(response.message)) {
              const errMessages = response.message;

              errMessages.forEach((msg, i) => {
                setTimeout(() => {
                  toast((t) => customToast(msg, "error", t), {
                    duration: 3000,
                    removeDelay: 1000,
                    style: {
                      padding: "0.75rem",
                      margin: "0",
                      width: "360px",
                      maxWidth: "100%",
                      // color: theme === 'light' ? 'rgb(33,37,41)' : 'rgb(230, 230, 230)',
                      // backgroundColor: theme === 'light' ? 'rgba(255,255,255,.9)' : 'rgb(51, 34, 61)'
                      color: "rgb(33,37,41)",
                      backgroundColor: "rgb(221, 204, 225)",
                    },
                  });
                }, i * 350);
              });
            } else {
              toast((t) => customToast(response.message, "error", t), {
                duration: 3000,
                removeDelay: 1000,
                style: {
                  padding: "0.75rem",
                  margin: "0",
                  minWidth: "200px",
                  backgroundColor: "rgb(221, 204, 225)",
                },
              });
            }
          }
        } else {
          toast((t) => customToast("Password don't match", "error", t), {
            duration: 3000,
            removeDelay: 1000,
            style: {
              padding: "0.75rem",
              margin: "0",
              minWidth: "200px",
              backgroundColor: "rgb(221, 204, 225)",
            },
          });
        }
      }
    } finally {
      setFormProcessing((prev) => !prev);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const response = await sendChangePasswordReq();
  };

  return (
    <div
      className={`add-custom-scroll${theme === "dark" ? "-dark" : ""} container-fluid w-100 d-flex mx-auto flex-column justify-content-start flex-nowrap`}
      style={{
        fontFamily: isRTL ? "var(--font-urdu)" : '"Barlow Condensed", "Kanit"',
        backgroundColor: "var(--theme-bg)",
        padding: screenSize <= 575 ? "8px 8px 8px 8px" : "4px 10px 10px 12px",
        borderRadius: "20px",
        rowGap: "8px",
        height: screenSize <= 575 ? "calc(100dvh - 148px)" : screenSize <= 991 && screenSize >= 576 ? "calc(100dvh - 202px)" : "calc(100dvh - 128px)",
        overflowY: "auto",
      }}
    >
      <div className='row w-100 min-vh-100 flex-column align-items-center justify-content-between mx-auto py-3 flex-nowrap' style={{
        height: '100%',
        minHeight: '700px'
      }}>
        <div className='col-auto p-0 text-center'>
              <img className="" src={LogoDark} style={{
                width: '300px',
                objectFit: 'contain',
                maxWidth: '100%'
              }}/>
          {/* <svg
            xmlns='http://www.w3.org/2000/svg'
            width={140}
            viewBox='0 0 24 24'
            fill='none'
            stroke='currentColor'
            strokeWidth={1.25}
            strokeLinecap='round'
            strokeLinejoin='round'
            className='icon icon-tabler icons-tabler-outline icon-tabler-stack-2 mx-auto'
            style={{
              color: "rgba(255,255,255,0.85)",
              overflow: "visible",
            }}
          >
            <path stroke='none' d='M0 0h24v24H0z' fill='none' />
            <path d='M12 4l-8 4l8 4l8 -4l-8 -4' />
            <path d='M4 12l8 4l8 -4' />
            <path d='M4 16l8 4l8 -4' />
          </svg>
          <div
            className=''
            style={{
              fontSize: "3rem",
              fontWeight: "700",
              letterSpacing: "0.02em",
              lineHeight: "1",
              color: "rgba(255, 255, 255, 0.9)",
            }}
          >
            One-App
          </div> */}
        </div>
        <div className='col-auto p-0 px-2 px-sm-4'>
          {/* <div className="text-center" style={{
						lineHeight: '1',
						fontSize: '1.2rem',
						color: 'rgba(255,255,255,0.7)'
					}}>
						Login via
					</div> */}

          <form
            className=''
            onSubmit={handleSubmit}
            style={{
              marginTop: "2.5rem",
              marginBottom: "2.5rem",
              width: "460px",
              maxWidth: "100%",
              backgroundColor: theme === "dark" ? "rgba(90, 90, 90, .6)" : "rgb(198, 204, 227, .38)",
              border: "1px solid rgba(255,255,255,.15)",
              borderRadius: ".5rem",
              padding: screenSize === "sm" ? "1.75rem 1.5rem 1.9rem 1.5rem" : "1.85rem 2rem 2.1rem 2rem",
              // maxWidth: '100%'
            }}
          >
            <div
              className='row w-100 flex-column flex-nowrap mx-auto gap-4 row-gap-2'
              style={{
                color: theme === "dark" ? "rgb(210, 210, 210)" : "rgb(53, 53, 53)",
                fontWeight: "400",
              }}
            >
              <div className='col-12 p-0'>
                <div className='' style={{}}>
                  {t("auth.change.old")}
                  {/* <sup style={{ color: 'rgb(239, 112, 112)', fontSize: '15px', top: '-.25em' }}>*</sup> */}
                </div>
                <div className='position-relative'>
                  <input
                    className='form-control'
                    placeholder=''
                    name='old_password'
                    value={formData.old_password}
                    onChange={updateFormData}
                    type={viewPassword.old_password ? "text" : "password"}
                    style={{
                      ...themeBasedSignupFormControl(theme),
                      // letterSpacing: '0.2em',
                      paddingInlineEnd: "2.2rem",
                      borderWidth: formErrors.old_password ? "2px" : "1px",
                      borderStyle: "solid",
                      borderColor: formErrors.old_password ? "rgb(239, 112, 112)" : theme === "dark" ? "rgb(250, 229, 255)" : "rgb(141, 136, 143)",
                      // fontWeight: '600',
                      fontSize: "1.1rem",
                      marginTop: ".25rem",
                    }}
                  />

                  {viewPassword.old_password ? (
                    <button
                      className='btn position-absolute top-0 end-0 h-100 d-flex align-items-center justify-content-center px-2'
                      type='button'
                      onClick={() => setViewPassword((prev) => ({ ...prev, old_password: !prev.old_password }))}
                      style={{
                        color: "var(--theme-light-secondary) !important",
                        border: "none",
                        boxShadow: "none",
                      }}
                    >
                      <svg
                        xmlns='http://www.w3.org/2000/svg'
                        width={24}
                        height={24}
                        viewBox='0 0 24 24'
                        fill='none'
                        stroke='currentColor'
                        strokeWidth={1.5}
                        strokeLinecap='round'
                        strokeLinejoin='round'
                        className='icon icon-tabler icons-tabler-outline icon-tabler-eye'
                      >
                        <path stroke='none' d='M0 0h24v24H0z' fill='none' />
                        <path d='M10 12a2 2 0 1 0 4 0a2 2 0 0 0 -4 0' />
                        <path d='M21 12c-2.4 4 -5.4 6 -9 6c-3.6 0 -6.6 -2 -9 -6c2.4 -4 5.4 -6 9 -6c3.6 0 6.6 2 9 6' />
                      </svg>
                    </button>
                  ) : (
                    <button
                      className='btn position-absolute top-0 end-0 h-100 d-flex align-items-center justify-content-center px-2'
                      type='button'
                      onClick={() => setViewPassword((prev) => ({ ...prev, old_password: !prev.old_password }))}
                      style={{
                        color: "var(--theme-light-secondary) !important",
                        border: "none",
                        boxShadow: "none",
                      }}
                    >
                      <svg
                        xmlns='http://www.w3.org/2000/svg'
                        width={24}
                        height={24}
                        viewBox='0 0 24 24'
                        fill='none'
                        stroke='currentColor'
                        strokeWidth={1.5}
                        strokeLinecap='round'
                        strokeLinejoin='round'
                        className='icon icon-tabler icons-tabler-outline icon-tabler-eye-off'
                      >
                        <path stroke='none' d='M0 0h24v24H0z' fill='none' />
                        <path d='M10.585 10.587a2 2 0 0 0 2.829 2.828' />
                        <path d='M16.681 16.673a8.717 8.717 0 0 1 -4.681 1.327c-3.6 0 -6.6 -2 -9 -6c1.272 -2.12 2.712 -3.678 4.32 -4.674m2.86 -1.146a9.055 9.055 0 0 1 1.82 -.18c3.6 0 6.6 2 9 6c-.666 1.11 -1.379 2.067 -2.138 2.87' />
                        <path d='M3 3l18 18' />
                      </svg>
                    </button>
                  )}
                </div>
              </div>
              <div className='col-12 p-0'>
                <div className='' style={{}}>
                  {t("auth.change.new")}
                  {/* <sup style={{ color: 'rgb(239, 112, 112)', fontSize: '15px', top: '-.25em' }}>*</sup> */}
                </div>
                <div className='position-relative'>
                  <input
                    className='form-control'
                    placeholder=''
                    name='password'
                    value={formData.password}
                    onChange={updateFormData}
                    type={viewPassword.password ? "text" : "password"}
                    style={{
                      ...themeBasedSignupFormControl(theme),
                      // letterSpacing: '0.2em',
                      paddingInlineEnd: "2.2rem",
                      borderWidth: formErrors.password ? "2px" : "1px",
                      borderStyle: "solid",
                      borderColor: formErrors.password ? "rgb(239, 112, 112)" : theme === "dark" ? "rgb(250, 229, 255)" : "rgb(141, 136, 143)",
                      // fontWeight: '600',
                      fontSize: "1.1rem",
                      marginTop: ".25rem",
                    }}
                  />
                  {viewPassword.password ? (
                    <button
                      className='btn position-absolute top-0 end-0 h-100 d-flex align-items-center justify-content-center px-2'
                      type='button'
                      onClick={() => setViewPassword((prev) => ({ ...prev, password: !prev.password }))}
                      style={{
                        color: "var(--theme-light-secondary) !important",
                        border: "none",
                        boxShadow: "none",
                      }}
                    >
                      <svg
                        xmlns='http://www.w3.org/2000/svg'
                        width={24}
                        height={24}
                        viewBox='0 0 24 24'
                        fill='none'
                        stroke='currentColor'
                        strokeWidth={1.5}
                        strokeLinecap='round'
                        strokeLinejoin='round'
                        className='icon icon-tabler icons-tabler-outline icon-tabler-eye'
                      >
                        <path stroke='none' d='M0 0h24v24H0z' fill='none' />
                        <path d='M10 12a2 2 0 1 0 4 0a2 2 0 0 0 -4 0' />
                        <path d='M21 12c-2.4 4 -5.4 6 -9 6c-3.6 0 -6.6 -2 -9 -6c2.4 -4 5.4 -6 9 -6c3.6 0 6.6 2 9 6' />
                      </svg>
                    </button>
                  ) : (
                    <button
                      className='btn position-absolute top-0 end-0 h-100 d-flex align-items-center justify-content-center px-2'
                      type='button'
                      onClick={() => setViewPassword((prev) => ({ ...prev, password: !prev.password }))}
                      style={{
                        color: "var(--theme-light-secondary) !important",
                        border: "none",
                        boxShadow: "none",
                      }}
                    >
                      <svg
                        xmlns='http://www.w3.org/2000/svg'
                        width={24}
                        height={24}
                        viewBox='0 0 24 24'
                        fill='none'
                        stroke='currentColor'
                        strokeWidth={1.5}
                        strokeLinecap='round'
                        strokeLinejoin='round'
                        className='icon icon-tabler icons-tabler-outline icon-tabler-eye-off'
                      >
                        <path stroke='none' d='M0 0h24v24H0z' fill='none' />
                        <path d='M10.585 10.587a2 2 0 0 0 2.829 2.828' />
                        <path d='M16.681 16.673a8.717 8.717 0 0 1 -4.681 1.327c-3.6 0 -6.6 -2 -9 -6c1.272 -2.12 2.712 -3.678 4.32 -4.674m2.86 -1.146a9.055 9.055 0 0 1 1.82 -.18c3.6 0 6.6 2 9 6c-.666 1.11 -1.379 2.067 -2.138 2.87' />
                        <path d='M3 3l18 18' />
                      </svg>
                    </button>
                  )}
                </div>
              </div>
              <div className='col-12 p-0'>
                <div className='' style={{}}>
                  {t("auth.change.repeat")}
                  {/* <sup style={{ color: 'rgb(239, 112, 112)', fontSize: '15px', top: '-.25em' }}>*</sup> */}
                </div>
                <div className='position-relative'>
                  <input
                    className='form-control'
                    placeholder=''
                    name='confirm_password'
                    value={formData.confirm_password}
                    onChange={updateFormData}
                    type={viewPassword.confirm_password ? "text" : "password"}
                    style={{
                      ...themeBasedSignupFormControl(theme),
                      // letterSpacing: '0.2em',
                      paddingInlineEnd: "2.2rem",
                      borderWidth: formErrors.confirm_password ? "2px" : "1px",
                      borderStyle: "solid",
                      borderColor: formErrors.confirm_password ? "rgb(239, 112, 112)" : theme === "dark" ? "rgb(250, 229, 255)" : "rgb(141, 136, 143)",
                      // fontWeight: '600',
                      fontSize: "1.1rem",
                      marginTop: ".25rem",
                    }}
                  />
                  {viewPassword.confirm_password ? (
                    <button
                      className='btn position-absolute top-0 end-0 h-100 d-flex align-items-center justify-content-center px-2'
                      type='button'
                      onClick={() => setViewPassword((prev) => ({ ...prev, confirm_password: !prev.confirm_password }))}
                      style={{
                        color: "var(--theme-light-secondary) !important",
                        border: "none",
                        boxShadow: "none",
                      }}
                    >
                      <svg
                        xmlns='http://www.w3.org/2000/svg'
                        width={24}
                        height={24}
                        viewBox='0 0 24 24'
                        fill='none'
                        stroke='currentColor'
                        strokeWidth={1.5}
                        strokeLinecap='round'
                        strokeLinejoin='round'
                        className='icon icon-tabler icons-tabler-outline icon-tabler-eye'
                      >
                        <path stroke='none' d='M0 0h24v24H0z' fill='none' />
                        <path d='M10 12a2 2 0 1 0 4 0a2 2 0 0 0 -4 0' />
                        <path d='M21 12c-2.4 4 -5.4 6 -9 6c-3.6 0 -6.6 -2 -9 -6c2.4 -4 5.4 -6 9 -6c3.6 0 6.6 2 9 6' />
                      </svg>
                    </button>
                  ) : (
                    <button
                      className='btn position-absolute top-0 end-0 h-100 d-flex align-items-center justify-content-center px-2'
                      type='button'
                      onClick={() => setViewPassword((prev) => ({ ...prev, confirm_password: !prev.confirm_password }))}
                      style={{
                        color: "var(--theme-light-secondary) !important",
                        border: "none",
                        boxShadow: "none",
                      }}
                    >
                      <svg
                        xmlns='http://www.w3.org/2000/svg'
                        width={24}
                        height={24}
                        viewBox='0 0 24 24'
                        fill='none'
                        stroke='currentColor'
                        strokeWidth={1.5}
                        strokeLinecap='round'
                        strokeLinejoin='round'
                        className='icon icon-tabler icons-tabler-outline icon-tabler-eye-off'
                      >
                        <path stroke='none' d='M0 0h24v24H0z' fill='none' />
                        <path d='M10.585 10.587a2 2 0 0 0 2.829 2.828' />
                        <path d='M16.681 16.673a8.717 8.717 0 0 1 -4.681 1.327c-3.6 0 -6.6 -2 -9 -6c1.272 -2.12 2.712 -3.678 4.32 -4.674m2.86 -1.146a9.055 9.055 0 0 1 1.82 -.18c3.6 0 6.6 2 9 6c-.666 1.11 -1.379 2.067 -2.138 2.87' />
                        <path d='M3 3l18 18' />
                      </svg>
                    </button>
                  )}
                </div>
              </div>
            </div>
            {/* {renderStep()} */}
            <button
              className='btn w-100 d-flex align-items-center justify-content-center gap-2 mx-auto'
              type='submit'
              disabled={formProcessing}
              style={{
                ...customRecoverButton,
                fontSize: "1.1rem",
                fontWeight: "600",
                letterSpacing: "0.02em",
                marginTop: "2.3rem",
                // maxWidth: '300px'
              }}
            >
              {formProcessing ? (
                <>
                  <span
                    className='spinner-border spinner-border-sm'
                    aria-hidden='true'
                    style={{
                      fontSize: "0.85rem",
                      height: "15px",
                      width: "15px",
                    }}
                  ></span>
                  <span role='status'>Loading...</span>
                </>
              ) : (
                t("auth.change.button")
              )}
            </button>
            <button
              className='btn w-100 d-flex align-items-center justify-content-center gap-2 mx-auto'
              type='button'
              onClick={navigateToHome}
              disabled={false}
              style={{
                ...customCancelButton,
                fontSize: "1.1rem",
                fontWeight: "600",
                letterSpacing: "0.02em",
                marginTop: ".3rem",
                // maxWidth: '300px'
              }}
            >
              {t("modals.common.cancel")}
            </button>
          </form>
        </div>
        <div className='col-auto p-0'>
          <div
            className='text-center'
            style={{
              lineHeight: "1",
              fontSize: "1.2rem",
              color: "rgba(255,255,255,0.7)",
            }}
          >
            {t("app.login.form.power")}
          </div>
          <img
            className=''
            src={DcclLogo}
            alt='Logo'
            style={{
              width: "160px",
            }}
          />
        </div>
      </div>
    </div>
  );
}

export default UpdatePasswordPage;
